// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".airport-name[data-v-0917fb58]  .el-form-item__content {\n  width: 18em;\n}", ""]);
// Exports
module.exports = exports;
